import { Component, EventEmitter, inject, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { WorkshopsResponse } from '../../../models/workshop-response.model';
import { WorkshopType } from '../../../enums/maintenance-settings.enum';

@Component({
  selector: 'app-workshop-list',
  standalone: true,
  imports: [CommonModule, TranslocoDirective],
  templateUrl: './workshop-list.component.html',
  styleUrl: './workshop-list.component.scss'
})
export class WorkshopListComponent implements OnChanges {
  @Input() workshops: WorkshopsResponse[] = [];
  @Input() selectedWorkshop: WorkshopsResponse | null = null;
  @Input() isLoading: boolean;
  @Output() workshopSelected = new EventEmitter<WorkshopsResponse>();

  private readonly transloco = inject(TranslocoService);

  workshopTypeLabels: Record<WorkshopType, string> = {
    [WorkshopType.InHouse]: this.transloco.translate('assetSettings.common.inHouse'),
    [WorkshopType.External]: this.transloco.translate('assetSettings.common.external')
  };

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedWorkshop'] && this.selectedWorkshop) {
      setTimeout(() => {
        const element = document.getElementById('workshop-card-' + this.selectedWorkshop?.id);
        element?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    }
  }
}